/** 登录成功写入 localStorage（与 Login.vue / AI2Login.vue callbackLogin 一致） */

const LOGIN_SESSION_KEYS = [
  'USER_TOKEN',
  'USER_INFO',
  'Auth',
  'level',
  'username',
  'cProxyUser',
  'isOpenWX',
  'isBindWX',
  'isGradeVersion',
  'userId',
  'spaceNumberDiscern',
  'waitHandleCustomerCountToday',
  'waitHandleRemindCountToday',
  'hideSimpleWord',
  'auditWord',
  'sysRootMenu',
  'cmApiStart',
  'rechargeCheck',
  'wxAvattr',
  'skbShowNewFunc',
];

export function getAuthToken() {
  return window.localStorage.getItem('USER_TOKEN') || '';
}

export function getUserInfo() {
  const raw = window.localStorage.getItem('USER_INFO');
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

/**
 * @param {Object} data 与 mmlogin 返回结构一致 { Auth, data: user }
 */
export function applyLoginSession(data) {
  const user = data.data;

  window.localStorage.setItem('USER_TOKEN', data.Auth);
  window.localStorage.setItem('USER_INFO', JSON.stringify(user));
  window.localStorage.setItem('Auth', data.Auth);
  window.localStorage.setItem('level', user.level);
  window.localStorage.setItem('username', user.username);
  window.localStorage.setItem('cProxyUser', user.cProxyUser);
  window.localStorage.setItem('isOpenWX', user.openWx);
  window.localStorage.setItem('isBindWX', true);
  window.localStorage.setItem('isGradeVersion', user.gradeVersion);
  window.localStorage.setItem('userId', user.id);
  window.localStorage.setItem('spaceNumberDiscern', user.spaceNumberDiscern);
  window.localStorage.setItem('waitHandleCustomerCountToday', user.waitHandleCustomerCountToday);
  window.localStorage.setItem('waitHandleRemindCountToday', user.waitHandleRemindCountToday);
  window.localStorage.setItem('hideSimpleWord', user.hideSimpleWord);
  window.localStorage.setItem('auditWord', user.auditWord);
  window.localStorage.setItem('sysRootMenu', user.sysRootMenu);
  window.localStorage.setItem('cmApiStart', user.cmApiStart);
  window.localStorage.setItem('rechargeCheck', user.rechargCheck ? 'true' : 'false');
  window.localStorage.setItem('skbShowNewFunc', user.skbShowNewFunc ? 'true' : 'false');
  if (user.wxHeadimgURL) {
    window.localStorage.setItem('wxAvattr', user.wxHeadimgURL);
  }
}

/** 与 SingleLogin callbackGetProtocol 一致 */
export function applyProtocolFlags(protocolData) {
  if (!protocolData) {
    return;
  }
  const enableWeixinPushFun = protocolData.enableWeixinPushFun == 1;
  const enableImportUsepassFun = protocolData.enableImportUsepassFun == 1;
  const enableRepeatFun = protocolData.enableRepeatFun == 1;
  const enabledTts = protocolData.enabledTts ? protocolData.enabledTts : false;
  const enabledGlobalThirdBigModel = protocolData.enabledGlobalThirdBigModel ? protocolData.enabledGlobalThirdBigModel : false;
  const enableReDialNeedpass = protocolData.enableReDialNeedpass == 1;
  window.localStorage.setItem('huluwa.enableWeixinPushFun', enableWeixinPushFun);
  window.localStorage.setItem('huluwa.enableImportUsepassFun', enableImportUsepassFun);
  window.localStorage.setItem('huluwa.enableRepeatFun', enableRepeatFun);
  window.localStorage.setItem('huluwa.enabledTts', enabledTts);
  window.localStorage.setItem('huluwa.enabledGlobalThirdBigModel', enabledGlobalThirdBigModel);
  window.localStorage.setItem('huluwa.enableReDialNeedpass', enableReDialNeedpass);
  window.localStorage.setItem('huluwa.enableThirdSystem', protocolData.enableThirdSystem);
  window.localStorage.setItem('huluwa.enableAi2Version', protocolData.enableAi2Version);
}

export function clearLocalLoginSession() {
  LOGIN_SESSION_KEYS.forEach((key) => {
    window.localStorage.removeItem(key);
  });
  window.localStorage.setItem('Y_REMENBERME', 'false');
}

export function setAuthItem(key, value) {
  window.localStorage.setItem(key, value);
}



// WEBPACK FOOTER //
// ./src/utils/authSession.js